module.exports = __webpack_public_path__ + "4bb38aaae84bd3e334d0d2058acc732c.MP3";